import * as React from "react";
import { useParams } from "react-router-dom";

import KeyPermissionForm from "../../../components/Forms/KeyPermissions/FlowForm/FlowForm";

export default () => {
  const { objectType, objectId } = useParams();
  const apartment = objectType === "apartment" ? objectId : undefined;
  const industrial = objectType === "industrial-premises" ? objectId : undefined;
  const common = objectType === "common-area" ? objectId : undefined;

  return <KeyPermissionForm method="POST" apartment={apartment} industrialPremises={industrial} commonArea={common}/>;
};
